import { createIntl, createIntlCache } from 'react-intl';
import nlTranslations from './nl.translations';

export enum Locales {
  NL = 'nl',
}

const locales = [Locales.NL];

const translations = {
  [Locales.NL]: {
    ...nlTranslations,
  },
};

const intl = createIntl(
  {
    locale: Locales.NL,
    messages: translations[Locales.NL],
  },
  createIntlCache(),
);

export type ITranslations = keyof typeof nlTranslations;
export { intl, locales, translations };
